<template>
  <b-card no-body class="d-inline-block indicator-card" :border-variant="variant" :bg-variant="lightColor">
    <div class="small indicator-text" :class="textColor">
      <slot></slot>
    </div>
  </b-card>
</template>

<style scoped>
.indicator-text {
  font-weight: 600;
  padding: 6px 30px;
}
.indicator-card {
  border-width: 1px;
  border-radius: 3px;
}
</style>

<script>
export default {
  props: {
    variant: { type: String, required: false, default: 'secondary' },
  },
  computed: {
    lightColor () {
      return 'light-' + this.variant
    },
    textColor () {
      return 'text-' + this.variant
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/StatusIndicator.vue